import {
  Outlet,
  createFileRoute,
  useLocation,
} from "@tanstack/react-router";

import { Progress } from "@/components/ui/progress";

export const Route = createFileRoute("/plugin/figma/onboarding")({
  component: OnboardingLayout,
});

function OnboardingLayout() {
  const pathname = useLocation({ select: (l) => l.pathname });

  return (
    <>
      <Progress
        className="rounded-none"
        value={
          pathname.includes("1")
            ? 25
            : pathname.includes("2")
              ? 50
              : pathname.includes("3")
                ? 75
                : pathname.includes("4")
                  ? 100
                  : 0
        }
      />
      <Outlet />
    </>
  );
}
